import { Component, Input, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { SolicitudResumidasModel } from 'src/app/models/credits-application/solicitud.model';

@Component({
  selector: 'app-solicitud-preautorizada',
  templateUrl: './solicitud-preautorizada.component.html',
  styleUrls: ['./solicitud-preautorizada.component.scss']
})
export class SolicitudPreautorizadaComponent implements OnChanges {

  // PARAMETROS RECIBIDOS
  @Input() solicitudesPreautorizadas: SolicitudResumidasModel[];

  constructor(
    private router: Router,
  ) { }

  ngOnChanges(): void {}

  // METODOS HTML
  visualizarSolicitud(solicitud: SolicitudResumidasModel) {

    const route = '/firma-contrato-pagare';
    this.router.navigate([route], {
      queryParams: {
        numSolicitud: solicitud.numSolicitud,
        claveTipoSolicitud: solicitud.tipoSolicitud.clave
      }
    });
  }

}
